import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { EntryContainer } from './containers/entry-container';
import { entryRoutePaths } from './models/path-model';

const StoriesListPage = React.lazy(() => import('./pages/stories-list-page'));
const NewStoryPage = React.lazy(() => import('./pages/new-story-page'));
const StoryStepsPage = React.lazy(() => import('./pages/story-steps-page'));
const StoryResumePage = React.lazy(() => import('./pages/story-resume-page'));

export const entryRoutes: Sebrae.RoutesConfig = [
  {
    routePath: entryRoutePaths.storiesList,
    pageToRender: (
      <EntryContainer>
        <StoriesListPage />
      </EntryContainer>
    ),
    ifIsAuthenticated: true,
  },
  {
    routePath: entryRoutePaths.newStory,
    pageToRender: (
      <EntryContainer>
        <NewStoryPage />
      </EntryContainer>
    ),
    ifIsAuthenticated: true,
  },

  {
    routePath: entryRoutePaths.storySteps,
    pageToRender: (
      <EntryContainer>
        <StoryStepsPage />
      </EntryContainer>
    ),
    ifIsAuthenticated: true,
  },
  {
    routePath: entryRoutePaths.storyResume,
    pageToRender: (
      <EntryContainer>
        <StoryResumePage />
      </EntryContainer>
    ),
    ifIsAuthenticated: true,
  },
  {
    routePath: entryRoutePaths.storyReview,
    pageToRender: (
      <EntryContainer>
        <StoryResumePage mode="review" />
      </EntryContainer>
    ),
    ifIsAuthenticated: true,
  },
];
